var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.465 10.963h-.787l-.28-.269a6.48 6.48 0 0 0 1.476-5.322C12.405 2.602 10.092.39 7.3.05A6.485 6.485 0 0 0 .05 7.296c.34 2.79 2.553 5.102 5.325 5.57a6.48 6.48 0 0 0 5.325-1.474l.27.279v.787l4.238 4.236a1.054 1.054 0 0 0 1.485 0 1.05 1.05 0 0 0 0-1.485zm-5.983 0a4.48 4.48 0 0 1-4.487-4.485 4.48 4.48 0 0 1 4.487-4.484 4.48 4.48 0 0 1 4.488 4.484 4.48 4.48 0 0 1-4.488 4.485"
  })));
};
export default SvgSearch;